type DirectionTypes = 'up' | 'down' | 'left' | 'right';

const getDirection = (direction: DirectionTypes) => {
  switch (direction) {
    case 'down':
      return 'rotate(-360deg)';
    case 'up':
      return 'rotate(-180deg)';
    case 'left':
      return 'rotate(-270deg)';
    case 'right':
      return 'rotate(-90deg)';
    default:
      return 'rotate(-360deg)';
  }
};

interface ICaret {
  color?: string;
  className?: string;
  'data-qa'?: string;
  direction?: DirectionTypes;
  size?: number;
  strokeWidth?: number;
  onClick?: () => void;
}

export const Caret = ({
  className,
  color,
  'data-qa': dataQa,
  direction = 'down',
  size,
  strokeWidth = 1,
  onClick,
}: ICaret) => {
  return (
    <svg
      className={className}
      width={size || 10}
      height={size || 6}
      style={{
        transform: getDirection(direction),
        transition: 'all .25s ease-in-out',
      }}
      data-qa={dataQa || 'caret_icon'}
      onClick={onClick}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="caret-icon"
    >
      <path d="M1 1L5 5L9 1" strokeWidth={strokeWidth} stroke={color || 'black'} />
    </svg>
  );
};
